import { useMemo } from 'react';
import { store }   from 'index';

const useDropDownVariant = ( openDropDown: string ) => {

  const state        = store.getState();
  const sizeState    = state.size;

  const dropDownVariant = useMemo(() => {

    if (!sizeState.wideScreen) {
      if (['links', 'selfTeaching'].includes(openDropDown)) {
        return openDropDown;
      }
     } 
     
     return 'default';

  },[sizeState, openDropDown])


  return dropDownVariant;
}


export default useDropDownVariant;



